// import { axios } from '@/lib/axios';

// import { AuthUser, UserResponseDetail } from '../types';

// import storage from '@/utils/storage';


// var token = storage.getToken();
// export const getUser = (): Promise<AuthUser> => {
//   return axios.get('/api/v1/user/userdetail' );
// };

// export const getUserDetail = (): Promise<UserResponseDetail> => {
//   return axios.get('/api/v1/user/userdetail' );
// };
import { axios } from '@/lib/axios';
import { AuthUser, UserResponseDetail } from '../types';
import storage from '@/utils/storage';

var token = storage.getToken();

export const getUser = async (): Promise<AuthUser | null> => {
  try {
    const response = await axios.get('/api/v1/user/userdetail');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch user:', error);
    return null;
  }
};

export const getUserDetail = async (): Promise<UserResponseDetail | null> => {
  try {
    const response = await axios.get('/api/v1/user/userdetail');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch user detail:', error);
    return null;
  }
};
